const appToken = 'dV2FAG9ycvCR';

export function initConpass({ user, userGroup }) {
  const userData = {
    name: user.name,
    email: user.email,
    custom_fields: {
      userGroup,
      userId: user.id,
    }
  };
  document.addEventListener('onconpassload', () => instantiateConpass(userData));
  const script = document.createElement('script');
  script.src = `https://fast.conpass.io/${appToken}.js`;
  document.body.appendChild(script);
}

export function instantiateConpass(userData) {
  if (window.Conpass) {
    window.Conpass.init(userData);
  }
}
